import type { ClientConfig } from '@workspace/public-utils'

const lottomdConfig: ClientConfig = {
  brandName: '로또명당',
  brandNameEn: 'LOTTOMD',
  logoIconText: 'M',
  logoIconColor: '#2b6856',
  defaultSiteName: '로또명당',
  seoTitleSuffix: '공식 로또 번호 생성 서비스',
  tagline: '한 주의 기대를 담는 곳',
  subTagline: '나의 숫자와 지난 기록을 한 장의 번호표에 담아드립니다',
  copyrightFallback: '로또명당(Lottomd)',
  ctaJoinText: '지금 바로 로또명당에 가입하고 첫 복권을 구매해보세요',
  whyChooseUs: '왜 로또명당을 선택해야 할까요?',
  statsSubtitle: '로또명당과 함께한 놀라운 성과들',
  joinNowCta: '지금 바로 로또명당과 함께하세요!',
  smartSystemCta: '로또명당의 스마트 번호 생성 시스템으로 다음 회차에 도전하세요',
  registerWelcome: 'LOTTOMD 로또명당과 함께하세요',
}

export default lottomdConfig
